module.exports = __webpack_public_path__ + "static/img/start-prediction-icon.7fda4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/start-prediction-icon.png
// module id = lRNn
// module chunks = 1